import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseSiteService, OccEndpointsService } from '@spartacus/core';
import { throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../spartacus/features/asm/asm-constant';
import { StorageService } from '../storage/storage.service';

export interface ForgotPayload {
  userId: string;
}

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  constructor(
    protected http: HttpClient,
    protected baseService: BaseSiteService,
    private occEndpointsService: OccEndpointsService,
    private storageService: StorageService
  ) {}

  postForgottenPassword(payload: ForgotPayload) {
    const params = new HttpParams().set('emailAddress', payload.userId);
    const asmQuery =
      this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY) === 'true' ? `?asm=true` : '';
    return this.http
      .post(this.occEndpointsService.buildUrl(`/forgottenpasswordtokens${asmQuery}`), null, { params })
      .pipe(map((data) => data));
  }

  errorHandlr(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
